export default __webpack_public_path__ + "static/media/image-contents.94932c25.png";